import ApiService from '@/core/services/ApiService';
import { Storage } from '@/core/helpers/Storage';
import { Encryption } from '@/core/helpers/Encryption';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Endpoints } from '@/api/ApiEndpoints';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';



@Module
export default class ErrorModule extends VuexModule {
	errors = {};
	/**
	 * Get authentification errors
	 * @returns array
	 */
	get getErrors() {
		return this.errors;
	}

	@Action
	[Actions.SET_ERROR](error) {
		this.context.commit(Mutations.SET_ERROR, error)
	}
	@Mutation
	[Mutations.SET_ERROR](error) {
		if (error == null) {
			this.errors = {};
			return;
		}
		if (typeof error === 'string') {
			this.errors = { Error: [error] };
			return;
		}
		if (Array.isArray(error)) {
			this.errors = { Error: error };
			return;
		}
		this.errors = { ...error };
	}
}
